export default "__VITE_ASSET__CCMZIKxU__"